import React from 'react';

const DocumentDownloadListItem = ({ item }) => (
  <li className="c-list__item">
    <a className="" tabIndex="-1" href={item.url} target={item.documentTarget || "_blank"} aria-label={item.title} data-track="contentDownload" data-track-info={`{'component':'DocumentDownload','fileName':'${item.title}'}`}>
      <span aria-hidden="true" className={`${item.icon || 'c-icon--pdf'} c-icon c-list__icon`}></span>
      <span>{item.title}</span>
    </a>
  </li>
);

export default DocumentDownloadListItem;